import api from "../../utils/api";
import { Endpoint, getEndpointURL } from "../common/endpoints";
export const userCreate = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.UserCreate), {
        credentials: "include",
        headers,
        json: {
            users: body,
        },
    }).json();
};
export const userList = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserList), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const userShowSelf = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserShowSelf), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userSelf = async (userId, body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserSelf, { userId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userSecurityQuestionsSelf = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserSecurityQuestionsSelf), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userSecurityQuestions = async (userId, body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserSecurityQuestions, { userId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userUpdateSelf = async (body, _queryParams, headers) => {
    return api.API.put(getEndpointURL(Endpoint.UserUpdateSelf), {
        credentials: "include",
        headers,
        json: {
            users: body,
        },
    }).json();
};
export const userUpdate = async (userId, body, _queryParams, headers) => {
    return api.API.put(getEndpointURL(Endpoint.UserUpdate, { userId }), {
        credentials: "include",
        headers,
        json: {
            users: body,
        },
    }).json();
};
export const userEnable = async (userId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.UserEnable, { userId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userDisable = async (userId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.UserDisable, { userId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userCreateOnfidoToken = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.UserCreateOnfidoToken), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userVerifySelf = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.UserVerifySelf), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userEnforcePasswordReset = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserEnforcePasswordReset), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const userListOrganisations = async (userId, body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserListOrganisations, { userId }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const userListOrganisationsSelf = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserListOrganisationsSelf), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const userListNotificationsSelf = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.UserListNotificationsSelf), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
